/** @format */

import {
	Accordion,
	AccordionButton,
	AccordionIcon,
	AccordionItem,
	AccordionPanel,
	Box,
	Container,
	Grid,
	GridItem,
	useBreakpoint,
	Text
} from '@chakra-ui/react';
import {WYSIWYG as WYSIWYGComponent} from '../../components/WYSIWYG';
import {getDomainFontFamily} from '../../utils';
import {textStyles} from '../../styles/js/textStyles';

export default ({ accordions, subdomain }) => {

	return (
		<Box bg='white' as='section' overflow='hidden' position='relative'>
			<Container position='relative' maxW='container.xl' mx='auto'>
				<Accordion allowMultiple>
					{accordions &&
						accordions.map((accordionItem, index) => (
							<AccordionBody
								key={`${accordionItem.title}-${index}`}
								accordionItem={accordionItem}
								subdomain={subdomain}
							/>
						))}
				</Accordion>
			</Container>
		</Box>
	);
};

const AccordionBody = ({accordionItem, subdomain}) => {
	const {title, wysiwygs} = accordionItem;

	let textStylesDefault = {...textStyles.headinglgGillSans};
	const domainFontFamily = getDomainFontFamily(subdomain);

	return (
		<AccordionItem>
			<AccordionButton>
				{subdomain === 'thegregory' ?
					<Box flex='1' textAlign='left'>
						<Text
							{...textStylesDefault}
							fontFamily={domainFontFamily}>
							{title}
						</Text>
					</Box>
					:
					<Box flex='1' textAlign='left'>
						{title}
					</Box>
				}
				<AccordionIcon />
			</AccordionButton>
			<AccordionPanel>
				<DynamicGridComponent wysiwygs={wysiwygs} subdomain={subdomain} />
			</AccordionPanel>
		</AccordionItem>
	);
};

const DynamicGridComponent = ({wysiwygs, subdomain}) => {
	if (!wysiwygs) return null;
	const breakpoint = useBreakpoint({ssr: true});

	// set number of columns based on the number of wysiwygs
	const numColumns =
		breakpoint === 'base' || breakpoint === 'sm' ? 1 : wysiwygs.length || 1;

	return (
		<Grid
			templateColumns={`repeat(${numColumns}, 1fr)`}
			gap={{base: '0', sm: '3.5rem'}}>
			{wysiwygs.map((wysiwyg, index) => (
				<GridItem key={index}>
					<WYSIWYGComponent html={wysiwyg} subdomain={subdomain} />
				</GridItem>
			))}
		</Grid>
	);
};
